import React from 'react';

const StatCard = ({ stat }) => {
  const cardStyle = {
    transition: 'all 0.3s ease',
    borderRadius: '12px',
    border: 'none',
    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
    cursor: 'pointer'
  };

  return (
    <div className="col-xl-3 col-md-6 mb-3">
      <div 
        className="card h-100" 
        style={{
          ...cardStyle,
          background: stat.bg,
          color: 'white'
        }}
      >
        <div className="card-body">
          <div className="d-flex justify-content-between align-items-center">
            <div>
              <h6 className="card-title mb-1" style={{ opacity: 0.9 }}>{stat.title}</h6>
              <h3 className="mb-0 fw-bold">{stat.value}</h3>
            </div>
            <div className="text-end">
              <div className="fs-1 mb-2">{stat.icon}</div>
              <div className={`badge rounded-pill ${stat.change.includes('+') ? 'bg-success' : stat.change === '0%' ? 'bg-secondary' : 'bg-danger'}`}>
                {stat.change}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StatCard;
